"use strict";
exports.__esModule = true;
exports.DocumentAssociation = void 0;
var tslib_1 = require("tslib");
var DocumentAssociation;
(function (DocumentAssociation) {
    DocumentAssociation["NONE"] = "association-none";
    DocumentAssociation["CONSENT"] = "association-consent";
    DocumentAssociation["EVALTOOLS"] = "association-evaltools";
})(DocumentAssociation = exports.DocumentAssociation || (exports.DocumentAssociation = {}));
(0, tslib_1.__exportStar)(require("./DocumentUpload"), exports);
//# sourceMappingURL=index.js.map